export default {
    title: 'ចូលជាសមាជិក',
    my_affiliate_info: 'ព័ត៌មានចូលជាសមាជិករបស់ខ្ញុំ',
    my_target_referer: 'អ្នកយោងគោលដៅរបស់ខ្ញុំ',
    affiliate_code: 'លេខកូដចូលជាសមាជិក',
    affiliate_link: 'តំណភ្ជាប់ចូលជាសមាជិក',
    affiliate_hint:
        'ចម្លងកូដ ឬ តំណរភ្ជាប់របស់អ្នក ហើយផ្ញើវាទៅមិត្តរបស់អ្នក ដើម្បីទទួលបានរង្វាន់',
    affiliate_target:
        'អ្នកនឹងទទួលបានកំរៃជើងសារចំនួន {commissionAmount} ងមួយនាក់នៅពេលដែលពួកគេឈានដល់ការចំណាយចាប់ចំនួន {earnLimit}.',
    note: 'ចំណាំ៖ កម្រៃជើងសារ ត្រូវបង់ជាក្រេឌីតផ្សព្វផ្សាយដើម្បីទិញសេវាកម្មរបស់ 1Byte',
    earned_promo_credit: 'ទទួលបានឥណទានផ្សព្វផ្សាយ',
    referees: 'អាជ្ញាកណ្តាល',
    registration_date_from: 'កាលបរិច្ឆេទចុះឈ្មោះពី',
    due_date_from: 'កាលបរិច្ឆេទផុតកំណត់ពី',
    issue_date_from: 'កាលបរិច្ឆេទចេញផ្សាយពី',
    target_from: 'បរិមាណគោលដៅពី',
    earned_from: 'ចំនួនដែលទទួលបានពី',
    username: 'ឈ្មោះ អ្នកប្រើប្រាស់',
    registration_date: 'កាលបរិច្ឆេទ ចុះបញ្ជី',
    due_date: 'កាលបរិច្ឆេទ​ផុត​កំណត់',
    issue_date: 'កាលបរិច្ឆេទចេញផ្សាយ',
    target: 'គោលដៅ',
    earned: 'បានកំរ៉ៃ',
    reward: 'រង្វាន់',
    referer_target_note:
        'អ្នកនឹងទទួលបានកំរៃជើងសារ {amount} នៅពេលអ្នកទៅដល់គោលដៅ។',
};
